import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { autobind } from 'packages/core/lib';
import { setMetricsEvent } from '../../actions/metrics';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import Spinner from '../../components/Spinner';
import Device from '../../devices/device';
import { Grid, Row, Column, HeaderCompound, TransactionTitle } from '../../packages/components';
import { PlanSelector as PlanSelectorComponent, IPlanSelectorItemProps } from '../../packages/components/lib/PlanSelector';
import { IDetailSelector } from '../DetailSelector'
import * as PlanSelectorUtils from './PlanSelectorUtils';
import Translator from '../../requests/apa/Translator';
import Asset from "../../requests/apa/Asset";
import { showError, getTransactionalLabels } from '../utils/Utils';
import { METODO_DE_PAGO, SELECCION_DE_PLAN, LABEL_CONTRATA, LABEL_BUTTON_QUE_INCLUYE } from '../../packages/components/lib/utils/constants';
import { GA4 } from 'src/utils/trackers/GA4';
import { CONTENT_TYPE_TV, CONTENT_SECTION_START, CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION, DOES_NOT_APPLY } from 'src/utils/trackers/GA4Constants';
import { getProductTypes } from './PSUtils'; 
import './_styles.scss';


interface IProps {
  errorMsg: string;
}

interface PlanSelectorData {
  //TODO: check props interface to delete any type
  addon: any;
  ImagenFondo_aaf: string;
}

interface IPlanselectorState {
  plans: IPlanSelectorItemProps[];
  details: IDetailSelector[];
  isLoading: boolean;
  cardData: any;//PlanSelectorData[];
}

declare var window: any;
class PlanSelectorNew extends Component<RouteComponentProps & IProps, IPlanselectorState> {
  public keys = Device.getDevice() && Device.getDevice().getKeys() || null;

  constructor(props: RouteComponentProps & IProps) {
    super(props);
    this.state = {
      isLoading: true,
      plans: [],
      details: [],
      cardData: []
    };
    this.keys = Device.getDevice().getKeys();
  }

  componentDidMount() {
    this.getPlans();
    this.addEventListener();
  }

  componentWillUnmount() {
    this.removeEventListener();
  }

  private getActivePlan(offerid: string): any {
    const { plans, details } = this.state;
    const plan = plans.find((plan) => plan.id === offerid)
    const detail = details.find((detail) => detail.id === offerid)
    const { onPlanClick, ...restactivePlan } = plan || {};
    const activePlan = { ...restactivePlan, ...detail };

    return activePlan;

  }

  private handleBlueButton = (offerid: string): void => {
    const { history } = this.props;

    const activePlan = this.getActivePlan(offerid);
    const planSelected = this.getPlanName(activePlan.provider);

    this.sendMetric(METODO_DE_PAGO, SELECCION_DE_PLAN, `${planSelected.toLowerCase()} - ${LABEL_BUTTON_QUE_INCLUYE}`,);
    history.push('/detailSelector', { activePlan, metricsHistoryAddon: true });

  }

  @autobind
  private handleKeyDown(e: KeyboardEvent): void {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
    switch (currentKey) {
      case "YELLOW":
      case "BACK":
        this.handleBack();
        break;
    }
  }

  @autobind
  handleBack() {
    const { history } = this.props;
    history.goBack();
  };

  addEventListener() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keydown", this.handleKeyDown);
  }

  removeEventListener() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  @autobind
  sendDimension() {
    const { setMetricsEvent } = this.props;
    const payload = new AnalyticsDimensionSingleton().getPayload();
    setMetricsEvent(payload);
    setMetricsEvent({ type: 'executor' });
  }

  @autobind
  handlePlanClick(pbi: any) {
    const { history } = this.props;
    const eventLabel = this.getPlanName(pbi.producttype);
    this.sendMetric(METODO_DE_PAGO, SELECCION_DE_PLAN, `${LABEL_CONTRATA} ${eventLabel.toLowerCase()}`);
    this.sendGA4Metric(pbi);
    const { purchasable, offerid } = pbi;

    if (purchasable) {
      history.push(`/detailtransaction`, { ...pbi, from: 'plan-selector' });
    } else {
      const activePlan = this.getActivePlan(offerid);
      history.push('/detailSelector', { activePlan, metricsHistoryAddon: true });
    }
  }

  @autobind
  sendGA4Metric(pbi: any) {
    console.log('++++++++GA4 sendGA4Metric [PLAN SELECTOR] props ', this.props);
    const { offerid, price, producttype, frequency, family } = pbi;
    const ga4 = new GA4();
    const id = offerid;
    const name = producttype;
    const category = CONTENT_TYPE_TV;
    const category2 = DOES_NOT_APPLY;
    const category3 = CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION;
    const category4 = DOES_NOT_APPLY;
    const brand = family;
    const list_name = CONTENT_SECTION_START;
    const quantity = frequency;
    ga4.sendPlanSelectorEvent(id, name, category, category2, category3, category4, brand, list_name, price || '0.00', quantity);
  }

  @autobind
  sendMetric(component: string, action: string, label: string) {
    const { setMetricsEvent } = this.props;
    setMetricsEvent({
      hitType: 'event',
      eventCategory: component,
      eventAction: action,
      eventLabel: label
    });
    setMetricsEvent({ type: 'executor' });
    this.sendDimension();
  }

  getPlans() {
    PlanSelectorUtils.getPlans({ object_type: 'A' }).then(res => {

      const labels = getTransactionalLabels();
      const { response: { listButtons: { button = [] } = {} } } = res || {};
      const plans = res.response.listButtons ? PlanSelectorUtils.parsePlans(button, (plan: any) => {
        this.handlePlanClick(plan);
      }, labels) : []

      const details = res.response.listButtons ? PlanSelectorUtils.parseDetailPlan(button, labels) : [];
      this.getData(plans);
      this.setState({
        plans,
        details,
      }, () => {
        window.SpatialNavigation.focus();
      })
    }).catch(err => {
      this.setState({ isLoading: false },
        () => {
          window.SpatialNavigation.focus();
        });
      showError(err);
    });
  }

  getPlanName(producttype: any) {
    return producttype.replace('_', ' ')
  }

  /**
   * @param pbi 
   * @returns an api call response metadata and asset
   */
  async getData (plans: any) {
    const cardData: any = await getProductTypes(plans);
    if (cardData?.cardData.length > 0) {
      this.setState({ cardData: cardData?.cardData, isLoading: false });
    } else {
      this.setState({ isLoading: false });
    }
  }

  public render(): JSX.Element {
    const { isLoading, cardData } = this.state;
    if (isLoading) {
      return <Spinner className="plan-selector" loadingMessage='' />
    } else {
      return (
        <Grid className={Device.getDevice().getPlatform()}>
            <div>
              <HeaderCompound
                disabled
                onClick={this.handleBack}
                textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                icon={`${Asset.get('top_head_option_back')}`}
              />
              <TransactionTitle
                title={Translator.get('planSelector_access_title_label', 'Selecciona un plan y comienza a disfrutar del mejor contenido')}
                textStep={Translator.get('top_head_step_1_3_label', 'PASO 1 DE 3')}
              />
              <Row>
                <Column>
                  <PlanSelectorComponent cardData={cardData} onBlueButton={this.handleBlueButton} />
                </Column>
              </Row>
            </div>
        </Grid>)
    }
  }
}

export default connect(null, { setMetricsEvent })(withRouter(PlanSelectorNew));



// WEBPACK FOOTER //
// ./src/payments/PlanSelector/index.tsx